<template>
  <div class="grid grid-flow-col grid-cols-8 gap-x-2">
    <label v-if="label" :for="id" class="col-span-2 flex leading-8">{{ label }}</label>
    <div class="col-span-6">
      <div class="relative w-full h-8 flex justify-end items-center">
        <input
          :id="id"
          type="text"
          :value="modelValue"
          ref="input"
          @change="changeValue"
          class="text-xxs h-8 relative px-1 rounded focus:border focus:border-indigo-600 focus:outline-none w-full border border-gray-100 bg-gray-100 cursor-default uppercase"
        >
        <div class="absolute w-5 h-5 mr-2 rounded" v-bind:style="{ backgroundColor: modelValue }"></div>
        <input
          type="color"
          :value="modelValue"
          ref="input"
          class="absolute w-5 h-5 mr-2 rounded opacity-0"
          @change="changeValue"
        > <!--(opacity-0) Hidees element to add custom styling on top-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  props:
  [
    "id",
    "label",
    "modelValue",
    "type",
    "mainSelectedNode",
    "model",
    "propertyName"
  ],
  
  methods: {
    async changeValue(event) {
      this.$emit('changeValue', event)
    }
  }
};
</script>
